module.exports = window["paypal"];